import { render, staticRenderFns } from "./CurvedColumns.vue?vue&type=template&id=3231567d&"
import script from "./CurvedColumns.vue?vue&type=script&lang=js&"
export * from "./CurvedColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CurvedColumns.vue"
export default component.exports